import { api } from "shared/redux/api"
import { useLazyQueryWithCallbacks } from "../../hooks/useLazyQueryWithCallbacks"
import { objectToQueryString } from "shared/utils/common"

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getClassSession: build.query({
      query: (arg) => {
        const { page, size, sort, start, end, type } = arg
        return {
          url: `/private/classSession/v2/scheduleByDate?page=${page}&size=${size}&sort=${sort}&start=${start}&end=${end}&type=${type}`,
        }
      },
    }),
    getCountLegend: build.query({
      query: (arg = {}) => {
        const { start, end } = arg
        return {
          url: `/private/classSession/v1/count?start=${start}&end=${end}`,
        }
      },
    }),
    getCountLegendLXO: build.query({
      query: (arg = {}) => {
        return {
          url: `/private/lxo/v1/count?${objectToQueryString(arg)}`,
        }
      },
    }),
    getLXOCountTeachers: build.query({
      query: (arg) => {
        return {
          url: `/private/lxo/v2/count?${objectToQueryString(arg)}`,
        }
      },
    }),
  }),
  overrideExisting: false,
})

export const {
  useLazyGetClassSessionQuery,
  useLazyGetCountLegendQuery,
  useLazyGetCountLegendLXOQuery,
  useLazyGetLXOCountTeachersQuery,
} = injectedRtkApi

export const useMyCalendarAPIs = {
  useGetClassSession: useLazyQueryWithCallbacks(useLazyGetClassSessionQuery),
  useGetCountLegend: useLazyQueryWithCallbacks(useLazyGetCountLegendQuery),
}
